import * as d3 from 'd3'
import { Ref, computed, onMounted, watch } from 'vue'

export function useComponent(
  group: Ref<SVGGElement | null>,
  draw: (args: {
    width: number
    height: number
    group: d3.Selection<SVGGElement, unknown, null, undefined>
    parentGroup: d3.Selection<SVGGElement, unknown, null, undefined>
    svg: d3.Selection<SVGSVGElement, unknown, null, undefined>
    padding: { top: number; right: number; bottom: number; left: number }
  }) => { destroy?: () => void } | void
) {
  const parentGroup = computed(
    () => (group.value?.parentElement ?? undefined) as SVGGElement | undefined
  )
  const svg = computed(
    () => (parentGroup.value?.parentElement ?? undefined) as SVGSVGElement | undefined
  )

  const width = computed(() => parentGroup.value?.getAttribute('width') ?? undefined)
  const height = computed(() => parentGroup.value?.getAttribute('height') ?? undefined)

  let destroy: (() => void) | undefined = undefined

  const rerender = () => {
    if (destroy) {
      destroy()
    }
    const width = parentGroup.value?.getAttribute('width')
    const height = parentGroup.value?.getAttribute('height')
    if (!width || !height || !group.value || !parentGroup.value || !svg.value) return
    group.value.innerHTML = ''
    const paddingString = parentGroup.value.getAttribute('data-padding')
    const ret = draw({
      width: parseInt(width),
      height: parseInt(height),
      group: d3.select(group.value),
      parentGroup: d3.select(parentGroup.value),
      svg: d3.select(svg.value),
      padding: paddingString ? JSON.parse(paddingString) : { top: 0, right: 0, bottom: 0, left: 0 }
    })
    if (ret?.destroy) {
      destroy = ret.destroy
    }
  }

  onMounted(() => {
    rerender()
  })
  watch([width, height, group, parentGroup, svg], () => rerender())

  watch(svg, () => {
    if (!svg.value) return
    new ResizeObserver(() => {
      rerender()
    }).observe(svg.value)
  })
}
